import React from "react";
import * as S from "./styled";
import { Container } from "reactstrap";
import range from "lodash/range";

const blockColors = [
  null,
  "rgba(172, 119, 190, 0.6)",
  "rgba(209, 23, 158, 0.24)",
  "rgba(30, 200, 163, 0.38)",
  "#E7E1BE",
];
const blocks = range(1, 5);
const perBlock = range(1, 5);

const Line = ({ color }) => (
  <S.Line>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 290.411 19.369"
      height="19.369"
      width="290.411"
      fill="none"
    >
      <path
        strokeMiterlimit="10"
        d="M.168 17.827c110.65-18.86 206.56-23 172.13-6.56-34.43 16.44 118-.82 118-.82"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  </S.Line>
);
export default ({ t }) => {
  return (
    <S.Wrap>
      <S.Head>
        <h3>{t("titles.4")}</h3>
        <span>{t("subtitles.4")}</span>
      </S.Head>
      <Container>
        <S.BlockContainer>
          {blocks.map((blockIdx) => (
            <S.Block key={blockIdx}>
              <S.BlockHead color={blockColors[blockIdx]}>
                {t(`features_${blockIdx}.head`)}
              </S.BlockHead>
              <Line color={blockColors[blockIdx]} />
              <S.List>
                {perBlock.map((itemIdx) => (
                  <li key={itemIdx}>
                    {t(`features_${blockIdx}.items.${itemIdx}`)}
                  </li>
                ))}
              </S.List>
            </S.Block>
          ))}
        </S.BlockContainer>
      </Container>
    </S.Wrap>
  );
};
